<form [formGroup]="stepSixForm" class="container-xxl">
  <div class="row justify-content-center">
    <div class="col" *ngIf="
      (cluster_singlebattery === 1 ? getClusterFieldAsFormArray(stepSixForm).length == 0
       : true) ">
      <div class="fs-5 fw-bold">{{"SYSTEM.STEPSIX.CLUSTERCOMPOSE" | translate}}</div>

      <button *ngIf="cluster_singlebattery === 1; else elsenotsingle" class="btn btn btn-outline-success mr-2"
        (click)="generateClusterDefault()">
        {{"SYSTEM.STEPSIX.ADDBATTERY" | translate}}
      </button>
      <ng-template #elsenotsingle>
        <button class="btn btn btn-outline-success mr-2" (click)="generateClusterDefault()">
          {{stepFourService.system_model == 6 ? ("SYSTEM.STEPSIX.ADDCABINET" | translate) : ("SYSTEM.STEPSIX.ADDCLUSTER"
          |
          translate)}}
        </button>
      </ng-template>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="container-fluid mt-4">
        <div class="row">
          <div *ngFor="let cluster of getClusterFieldAsFormArray(stepSixForm).controls ;let i = index;"
            formArrayName='clusters_list' class="mb-4 col-12 col-sm-6 col-lg-4">
            <div [formGroupName]="i">
              <mat-card>
                <mat-card-header class="bg-success bg-opacity-10">
                  <mat-card-title style="font-weight: bold; font-size: medium;">
                    <span *ngIf="cluster_singlebattery === 0; else elseEmpty">
                      {{stepFourService.system_model == 6 ? ("SYSTEM.STEPSIX.CABINET" |
                      translate) :
                      ("SYSTEM.STEPSIX.CLUSTER" | translate) }} {{i + 1}}
                    </span>
                    <ng-template #elseEmpty>
                      {{ "SYSTEM.STEPSIX.BATTERY" |
                      translate }}
                    </ng-template>
                  </mat-card-title>
                  <!-- Aggiungi il pulsante "X" per rimuovere -->
                  <button type="button" class="close" (click)="removeCluster(i)">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-card-header>
                <mat-card-content>
                  <div *ngFor="let bat of cluster.get('batteries').controls;let j = index" formArrayName="batteries">
                    <div [formGroupName]="j" class="row">
                      <!-- <div class="col-12"
                        style="margin-top: 0px; margin-bottom: 0px;padding-top: 0px; padding-bottom: 0px;"
                        [ngClass]="{'mt-2': j == 0}">
                        <span class="" *ngIf="cluster.get('batteries').controls.length > 1">
                          {{getStrMasterSlave(bat.get('masterorslave').value)}}
                        </span>
                      </div> -->
                      <div class="col-12" style="position: relative;">
                        <label style="font-weight: bold; font-size: small;" for="sn-{{i}}-{{j}}">
                          <span class="text-primary">{{getStrMasterSlave(bat.get('masterorslave').value)}}</span> {{ "SYSTEM.STEPSIX.SERIALNUMBER" | translate }}<sup
                            *ngIf="(stepFourService.system_model != 6) || (stepFourService.system_model == 6 && j == 0)">*</sup>
                        </label>
                        <input id="sn-{{i}}-{{j}}" class="form-control" type="text" formControlName="serialnumber"
                          [class.is-invalid]="bat.get('serialnumber')?.invalid && (bat.get('serialnumber')?.dirty || submitted)">
                        <app-scanner-barcode-button class="cameraIcon"
                          (barcodeScanned)="onBarcodeScanned($event, i)"></app-scanner-barcode-button>
                      </div>
                      <div class="col-12 text-danger mt-1"
                        *ngIf="bat.get('serialnumber')?.invalid && (bat.get('serialnumber')?.dirty || submitted)"
                        style="font-size: small;">
                        {{"SYSTEM.STEPSIX.SERIALNUMBERERROR" | translate}}
                      </div>
                    </div>
                  </div>
                  <label class="mt-2" style="font-weight: bold; font-size: medium;" for="inverters">
                    {{ "SYSTEM.STEPSIX.CONNECTEDINVERTER" | translate }}
                  </label>
                  <mat-form-field class="col-12" appearance="outline">
                    <mat-select formControlName="inverters" multiple>
                      @for (inverter of view_inverterslist; track inverter) {
                      <mat-option [value]="inverter.id">{{inverter.serialnumber}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </mat-card-content>

                <!-- <div class="field my-4 col-12">
              <p-multiSelect [options]="listaInverter" formControlName="inverter" optionLabel="sn"
                placeholder="Select inverter"></p-multiSelect>
            </div> -->
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="getClusterFieldAsFormArray(stepSixForm).length >1">
    <div class="col-12">
      <label class="form-check-label mt-3 mr-2" for="cluster_parallel">
        {{ "SYSTEM.STEPSIX.PARALLELCLUSTERS" | translate }}
      </label>
      <div class="form-check form-check-inline">
        <input class="form-check-input mt-1" type="radio" id="cluster_parallel_yes" [value]="1"
          formControlName="cluster_parallel">
        <label class="form-check-label" for="cluster_parallel_yes">{{ "SYSTEM.STEPSIX.YES" | translate }}</label>
      </div>
      <div class="form-check form-check-inline">
        <input class="form-check-input mt-1" type="radio" [value]="0" id="cluster_parallel_no"
          formControlName="cluster_parallel">
        <label class="form-check-label" for="cluster_parallel_no">{{ "SYSTEM.STEPSIX.NO" | translate }}</label>
      </div>
    </div>
  </div>
  <div *ngIf="!isReadonly; else updateBlock" class="col-12 text-center px-0">
    <button class="btn btn-outline-dark me-0 me-md-2" (click)="previous()">
      {{"SYSTEM.STEPBUTTONS.PREV" | translate}}
    </button>
    <button class="btn btn-outline-dark ms-1 me-1 ms-md-2 me-md-2" id="next" (click)="saveStep('save')">
      {{"SYSTEM.STEPBUTTONS.SAVE" | translate}}
    </button>
    <button class="btn btn-outline-dark me-0 ms-md-2"
      [disabled]="stepSixForm.invalid || this.clusterFieldAsFormArray.length == 0" id="next" (click)="saveStep('next')">
      {{"SYSTEM.STEPBUTTONS.NEXT" | translate}}
    </button>
  </div>
  <ng-template #updateBlock>
    <div class="col-12 text-center">
      <button class="btn btn-outline-dark" (click)="approvalRequested()">
        {{"SYSTEM.STEPBUTTONS.UPDATE" | translate}}
      </button>
    </div>
  </ng-template>
</form>
